/*
 * @Descripttion: 
 * @version: 
 * @Author: wangz
 * @Date: 2019-11-21 14:58:03
 * @LastEditors: hanzb
 * @LastEditTime: 2020-04-03 17:26:08
 */
/*  记录日志
 归属：企通前端平台-FC V2.0
 版权：2017-2020 企通软件技术有限公司
 --------------------------------------------------------------------------------
 作者：wangz                           创建日期：2017/03/29
 
 --------------------------------------------------------------------------------
 修改：hanzb                           修改日期：
 修改内容
 
 
 --------------------------------------------------------------------------------
 
 *******************************************************************************/

/**
 * 日志方法集，打印日志请统一使用该方法，统一管理日志
 * @namespace 日志方法集
 * @alias tool.sgiLogger
 */
var sgiLogger = {

	Level: {
		"error": 3,
		"warn": 2,
		"info": 1,
		"debug": 0,
		"debug-1": -1,
	},

	/**
	 * 校验日志等级
	 * @param {string} level <debug|info|warn|error>
	 * @private
	 */
	checkLevel: function (level) {
		return sgiConfig && sgiConfig.logger && (sgiConfig.logger.level <= this.Level[level]);
	},

	/**
	 * 不知道想用作什么
	 * @private
	 */
	setEnabled: function () {

	},

	/**
	 * 打印 JavaScript 函数调用堆栈
	 * 配置文件sgiConfig中的logger.stack=true时，开启调用栈打印
	 * 
	 * @private
	 */
	printCallStack: function () {
		if (sgiConfig && sgiConfig.logger && sgiConfig.logger.stack) {
			let error = new Error();
			let stack = error.stack.match(/(?:^|\n)[\s]*at.*/g)[2];
			console.debug("Error: 调用栈跟踪[非错误]" + stack);//"Error \n"为跟踪关键字，不能去掉或替换！！！
		}
	},

	/**
	 * 事件集使用，事件名称打印统一方法，级别为info（1级）
	 * @param {string} eventName 事件名称
	 */
	eventin: function (eventName) {
		if (this.checkLevel("info")) {
			console.log(">>>> eventin: ", eventName);
			this.printCallStack();
		}
	},

	/**
	 * 同console.log，级别为info（1级）
	 * @param  {...any} msg 同console.log
	 */
	log: function (...msg) {
		if (this.checkLevel("info")) {
			console.log(">>>> log: ", ...msg);
			this.printCallStack();
		}
	},

	/**
	 * 同console.info，级别为info（1级）
	 * @param  {...any} msg 同console.info
	 */
	info: function (...msg) {
		if (this.checkLevel("info")) {
			console.info(">>>> info: ", ...msg);
			this.printCallStack();
		}
	},

	/**
	 * 同console.debug，级别为debug（0级）
	 * @param  {...any} msg 同console.debug
	 */
	debug: function (...msg) {
		if (this.checkLevel("debug")) {
			console.debug(">>>> debug: ", ...msg);
			this.printCallStack();
		}
	},
	/**
	 * 日志级别降低为-1时，打印日志；可用于部分测试日志输出使用
	 * 同console.debug，级别为debug（-1级）
	 * @param  {...any} msg 同console.debug
	 */
	debug_1: function (...msg) {
		if (this.checkLevel("debug-1")) {
			console.debug(">>>> debug_1: ", ...msg);
			this.printCallStack();
		}
	},
	/**
	 * 同console.time，用于计时开始，级别为debug（0级）
	 * @param  {...any} msg 同console.time
	 */
	time: function (...msg) {
		if (this.checkLevel("debug")) console.time(...msg);
	},
	/**
	 * 同console.timeEnd，用于计时结束，级别为debug（0级）
	 * @param  {...any} msg 同console.timeEnd
	 */
	timeEnd: function (...msg) {
		if (this.checkLevel("debug")) console.timeEnd(...msg);
	},

	/**
	 * 同console.warn，级别为warn（2级）
	 * @param  {...any} msg 同console.warn
	 */
	warn: function (...msg) {
		if (this.checkLevel("warn")) {
			console.warn(">>>> warn: ", ...msg);
			this.printCallStack();
		}
	},

	/**
	 * 同console.error，级别为error（3级）
	 * @param  {...any} msg 同console.error
	 */
	error: function (...msg) {
		if (this.checkLevel("error")) {
			console.error(">>>> error: ", ...msg);
			this.printCallStack();
		}
	},

	/**
	 * 事件集使用，catch错误打印统一方法，级别为error（3级）
	 * @param {object} error 错误信息{string:message,errorStack:stack}
	 */
	eventErr: function (error) {
		if (this.checkLevel("error")) {
			// console.error(">>>> eventErr message: ", error.message);
			// console.error(">>>> eventErr stack: ", error.stack);
			console.error(error)
		}
	}
}

export { sgiLogger };
export default sgiLogger;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCommon/sgiLogger.js